import { Sports } from '../enums/sport';

export const style_font = {
  fill: 'rgba(0, 0, 0, 0.87)',
  fontSize: '36px',
  letterSpacing: '-1px',
  fontWeight: 700,
  textLength: '100%',
};

export const style_font_small = {
  fill: 'rgba(0, 0, 0, 0.87)',
  fontSize: '7px',
  letterSpacing: '0px',
  fontWeight: 700,
  textLength: '100%',
};

export const defaultKit = {
  colorCodes: ['#A0A0A0', '#FFFFFF'],
  patternId: 8,
  numberColor: '#000000',
  kitTypeId: 0,
  type: '',
  uid: '',
  sportId: Sports.FOOTBALL | Sports.ICE_HOCKEY | Sports.HANDBALL,
};
